import { render } from "./Ylogin.vue?vue&type=template&id=f627721c&scoped=true"
import script from "./Ylogin.vue?vue&type=script&lang=js"
export * from "./Ylogin.vue?vue&type=script&lang=js"

import "./Ylogin.vue?vue&type=style&index=0&id=f627721c&lang=css"
import "./Ylogin.vue?vue&type=style&index=1&id=f627721c&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f627721c"]])

export default __exports__